import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../authentication/services/authentication.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { jwtDecode } from "jwt-decode";

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);
  const token = localStorage.getItem('token');
  if (token && isTokenValid(token)) {
    return true;
  }

  const rememberMe = localStorage.getItem('rememberMe') === 'true';
  const refreshToken = localStorage.getItem('refresh_token');
  const issuedAt = localStorage.getItem('refresh_token_issued_at');
  
  if (rememberMe && refreshToken && issuedAt) {
    const issuedDate = new Date(parseInt(issuedAt));
    const now = new Date();
    const daysDiff = (now.getTime() - issuedDate.getTime()) / (1000 * 60 * 60 * 24);

    if (daysDiff <= 30) {
      return authService.refreshLogin(refreshToken).pipe(
        map((res: any) => {
          localStorage.setItem('user', JSON.stringify(res));
          localStorage.setItem('token', res.token);
          return true;
        }),
        catchError(() => {
          clearRefreshData();
          router.navigate(['/authentication']);
          return of(false);
        })
      );
    }
  }

  clearRefreshData();
  router.navigate(['/authentication']);
  return false;

  function isTokenValid(token: string): boolean {
    try {
      const decoded: any = jwtDecode(token); // ✅ Use .default when using import *
      const now = Math.floor(Date.now() / 1000);
      return decoded.exp > now;
    } catch {
      return false;
    }
  }

  function clearRefreshData() {
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('refresh_token_issued_at');
    localStorage.removeItem('rememberMe');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};
